import { useCallback } from "react";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { getRuntimeConfig } from "src/utils/runtime-config";
import { IGlobalSearchResponse, ISearchRequest } from "./search-autocomplete.api.types";

interface ISearchAutocompleteMutationVariables {
    underlyingsCount: number;
    wikifoliosCount: number;
    securityTypes?: number[];
    marketIndicatorsCount: number;
}

const DEFAULT_SEARCH_AUTOCOMPLETE_VARIABLES: ISearchAutocompleteMutationVariables = {
    underlyingsCount: 3,
    wikifoliosCount: 3,
    marketIndicatorsCount: 3,
};

export const useSearchAutocompleteMutation = (searchVariables: ISearchAutocompleteMutationVariables = DEFAULT_SEARCH_AUTOCOMPLETE_VARIABLES) => {
    const { country } = useRouterLocale();
    const { searchAutoCompleteEndpoint } = getRuntimeConfig();
    const { mutatePromise } = useMutation<IGlobalSearchResponse, unknown, ISearchRequest>(searchAutoCompleteEndpoint);

    return useCallback(
        async (searchTerm: string) =>
            await mutatePromise({
                country,
                fullText: searchTerm,
                ...searchVariables,
            }),
        [country, searchVariables, mutatePromise]
    );
};
